
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { CalendarClock } from 'lucide-react';

interface TransportationEmptyStateProps {
  onAddTransportation?: () => void;
  forSelectedDate?: boolean;
}

export const TransportationEmptyState: React.FC<TransportationEmptyStateProps> = ({
  forSelectedDate
}) => {
  return (
    <Card className="border border-gray-200">
      <CardContent className="p-6 flex flex-col items-center justify-center text-center">
        <CalendarClock className="h-12 w-12 text-muted-foreground mb-2 opacity-40" />
        <p className="text-muted-foreground mb-4">
          {forSelectedDate ? "No transportation details for this date." : "No transportation details have been added yet."}
        </p>
      </CardContent>
    </Card>
  );
};
